// extracted by mini-css-extract-plugin
export var columnList = "_a1-0";